import React from 'react';
import { usePageState } from '../page/page-state.hoc.js';
import { useAppContext } from '../app/app-context.hoc.js';
import { flattenAppContext } from '../util/flatten-app-context.js';
import { useNativeAppWebViewContext } from '../hooks/native-app-web-view-context.js';
const withLayout = (ContentComponent, layout = {}) => {
    const { HeaderComponent, FooterComponent, mainClassName = '' } = layout;
    const WithLayout = (props) => {
        const { isWebView } = useNativeAppWebViewContext();
        const { state } = usePageState();
        const appContext = flattenAppContext(useAppContext());
        return (React.createElement(React.Fragment, null,
            !isWebView && HeaderComponent && React.createElement(HeaderComponent, Object.assign({}, props, state, appContext)),
            React.createElement("main", { id: "content", className: 'main__content' + (mainClassName && ` ${mainClassName}`) },
                React.createElement(ContentComponent, Object.assign({}, props, state))),
            !isWebView && FooterComponent && React.createElement(FooterComponent, Object.assign({}, props, state, appContext))));
    };
    return WithLayout;
};
export { withLayout };
